import { css } from '@emotion/core';


export const PLAIN_GREEN_LINKS = css`
a {
    color: #73C724;
    text-decoration: none;
    font-weight: bold;
}`;

export const PLAIN_BLUE_LINKS = css`
a {
    color: #5698D6;
    text-decoration: none;
    font-weight: bold;
}`;
